
const headers = {
  name: "Accounts Payable",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "button",
      name: "export",
      label: "Export CSV",
      onClick: "exportFunction",
      icon: "download",
    },
  ],
  navigate: {
    tabs: [
     {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
      {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "",
      },
    ],
    total: [
      { value: 0, label: "Total Payable" },
      { value: 0, label: "Overdue Amount" },
      { value: 0, label: "Available Discounts" },
    ],
  },
};

export default headers;